import React from 'react';

import { Button, Typography } from '@material-ui/core';

import InputField from '../../common/components/inputField';
import classes from '../../css/getCSS';


const formatCountdown = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
};


const otpLoginForm = (props) => {
  const buttonLabel = props.otpSent ? 'Verify OTP' : 'Send OTP';

  return (
    <React.Fragment>
      <InputField
        id="email"
        config={{
          ...props.inputs.email,
          config: {
            ...props.inputs.email.config,
            disabled: props.otpSent,
          },
        }}
        changed={event => props.inputChangedHandler(event, 'email')}
      />
      <br />
      {props.otpSent && (
        <React.Fragment>
          <InputField
            id="otp"
            config={props.inputs.otp}
            changed={event => props.inputChangedHandler(event, 'otp')}
          />
          <br />
          {/*<Typography variant="body2" style={{ color: '#666', marginBottom: '8px' }}>*/}
          {/*  OTP is valid only for 5 minutes.*/}
          {/*</Typography>*/}
          {props.countdown > 0 && (
            <Typography variant="body2" style={{ color: '#666', marginBottom: '8px' }}>
              OTP expires in {formatCountdown(props.countdown)}
            </Typography>
          )}
          {props.countdown === 0 && (
            <Typography variant="body2" style={{ color: '#d32f2f', marginBottom: '8px' }}>
              OTP has expired. Please send a new OTP.
            </Typography>
          )}
          <br />
        </React.Fragment>
      )}
      <Button
        variant="contained"
        color="primary"
        type="submit"
        size="large"
        className={classes.Button}
        disabled={props.otpSent && props.countdown === 0}
      >
        {buttonLabel}
      </Button>
    </React.Fragment>
  );
};

export default otpLoginForm;



// WEBPACK FOOTER //
// ./src/auth/components/OtpLoginForm.js